
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education-serp",
      function () {
        return require("private-next-pages/education-serp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education-serp"])
      });
    }
  